import Ditherer from "./Ditherer";
export { default as Pixellator } from "./Pixellator";

export default Ditherer;
